import { render, staticRenderFns } from "./RowDefinitions.vue?vue&type=template&id=201f153a&"
import script from "./RowDefinitions.vue?vue&type=script&lang=js&"
export * from "./RowDefinitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports